module.exports = __webpack_public_path__ + "img/iptu-2025.6ee86d51.jpeg";